(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.header = null;
      this.announcementBar = null;
      this.headerIsAlwaysSticky = false;
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = null;
      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;
      this.isScrolling = null;
      this.isCollectionPage = false; // Track if on collection page
      this.isHomePage = false; // Track if on home page
    }

    connectedCallback() {
      if (this.hasAttribute('data-sticky-disabled')) {
        return; // Do not initialize sticky behavior on product pages
      }
      
      this.header = document.querySelector('.section-header');
      this.announcementBar = document.querySelector('.wknd-announcement');
      
      // Detect if on collection or home page via data attributes
      //this.isCollectionPage = this.getAttribute('data-collection-page') === 'true';
      this.isHomePage = this.getAttribute('data-home-page') === 'true';
      
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeights();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeights.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
        if (this.announcementBar) {
          this.announcementBar.classList.add('sticky-announcement');
        }
      }

      // If on a collection or home page, add the transparent header class initially
      // if ((this.isCollectionPage || this.isHomePage) && this.header) {
      //   this.header.classList.add('wknd-transparent-header');
      // }
      // If on home page only, add the transparent header class initially
      if (this.isHomePage && this.header) {
        this.header.classList.add('wknd-transparent-header');
      }

      this.predictiveSearch = this.querySelector('predictive-search');

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeights() {
      const headerHeight = this.header ? this.header.offsetHeight : 0;
      const announcementHeight = this.announcementBar ? this.announcementBar.offsetHeight : 0;
      const totalHeight = headerHeight + announcementHeight;

      document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      document.documentElement.style.setProperty('--announcement-height', `${announcementHeight}px`);
      document.documentElement.style.setProperty('--total-header-height', `${totalHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      if (this.header) {
        observer.observe(this.header);
      }
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling Down
        this.header.classList.add('scrolled-past-header');
        if (this.preventReveal) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        // Scrolling Up
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        // At the Top
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      // Update the current scroll position
      this.currentScrollTop = scrollTop;

      // Handle the transparent header class based on scrolled-past-header
      // if ((this.isCollectionPage || this.isHomePage) && this.header) {
      //   if (this.header.classList.contains('scrolled-past-header')) {
      //     // Remove the transparent header when scrolled past
      //     this.header.classList.remove('wknd-transparent-header');
      //   } else {
      //     // Add the transparent header when not scrolled past
      //     this.header.classList.add('wknd-transparent-header');
      //   }
      // }
      // Handle the transparent header class based on scrolled-past-header
      if (this.isHomePage && this.header) {
        if (this.header.classList.contains('scrolled-past-header')) {
          // Remove the transparent header when scrolled past
          this.header.classList.remove('wknd-transparent-header');
        } else {
          // Add the transparent header when not scrolled past
          this.header.classList.add('wknd-transparent-header');
        }
      }
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden');
      if (this.announcementBar) {
        this.announcementBar.classList.add('hidden-announcement');
      }
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      if (this.announcementBar) {
        this.announcementBar.classList.remove('hidden-announcement');
        this.announcementBar.classList.add('sticky-announcement');
      }
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
      if (this.announcementBar) {
        this.announcementBar.classList.remove('hidden-announcement', 'sticky-announcement');
      }
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
